import React from 'react';
import { Outlet } from 'react-router-dom'; 
import { HrManagementHeader } from '../shared/HrManagementHeader/HrManagementHeader';
// import HrManagementFooter from '../shared/HrManagementFooter/HrManagementFooter';
import "./HrManagementLayout.scss";

export const HrManagementLayout = () => {
  return (
    <>  
         <HrManagementHeader />
         <Outlet />
         {/* <HrManagementFooter /> */}
    </>
  )
}
